import { Input, InputNumber, Select, Row, Col, Checkbox, Tooltip } from 'antd';
import { Controller } from 'react-hook-form';
import FormItem from '../formItem';
import React from 'react';
import styled from 'styled-components';

// model type 1: image
// model type 2: audio/sound
// model type 3: time series

const normalizationTooltip = (
	<span>
		<p>การปรับขนาดข้อมูลตัวเลขให้อยู่ในช่วงเดียวกัน เพื่อให้โมเดลเรียนรู้ได้ดีขึ้นและเพิ่มประสิทธิภาพ</p>
		<p>โดยมีเทคนิคหลักๆ เช่น:</p>
		<ul style={{ marginLeft: '20px' }}>
			<li>Min-Max Normalization (ปรับช่วง 0-1)</li>
			<li>Standardization (ปรับค่าเฉลี่ย 0, ส่วนเบี่ยงเบนมาตรฐาน 1)</li>
		</ul>
		<p>การทำ Normalization จะช่วยให้โมเดล Machine Learning ทำงานได้รวดเร็วและแม่นยำยิ่งขึ้น</p>
		<a href="https://daysie.io/normalization" target="_blank" rel="noopener noreferrer">
			{' '}
			Learn more
		</a>
	</span>
);

const ConfigModelForm = ({ formProps, modelType }) => {
	const {
		control,
		formState: { errors },
	} = formProps;
	const isImageOrAudioModel = modelType === 1 || modelType === 2;

	return (
		<Row gutter={[10, 10]} align="bottom" style={{ width: '100%' }}>
			<Col xs={24} sm={8} md={5}>
				<ConfigFormItem label="Epoch" error={errors?.epoch?.message}>
					<Controller
						name="epoch"
						control={control}
						render={({ field }) => (
							<InputNumber
								style={{ width: '100%', borderRadius: 4 }}
								{...field}
								onChange={(value) => field.onChange(value === null ? null : parseInt(value))}
								min={5}
							/>
						)}
					/>
				</ConfigFormItem>
			</Col>
			<Col xs={24} sm={8} md={5}>
				<ConfigFormItem label="Batch size" error={errors?.batch?.message}>
					<Controller
						name="batch"
						control={control}
						render={({ field }) => (
							<Select {...field} style={{ width: '100%' }}>
								<Select.Option value={16}>16</Select.Option>
								<Select.Option value={32}>32</Select.Option>
								<Select.Option value={64}>64</Select.Option>
							</Select>
						)}
					/>
				</ConfigFormItem>
			</Col>
			{isImageOrAudioModel && (
				<Col xs={24} sm={8} md={5}>
					<ConfigFormItem label="Learning rate" error={errors?.rate?.message}>
						<Controller
							name="rate"
							control={control}
							render={({ field }) => (
								<InputNumber
									style={{ width: '100%', borderRadius: 4 }}
									{...field}
									min="0.0001"
									max="0.001"
									step="0.0001"
									onChange={(value) => field.onChange(value === null ? null : value)}
									stringMode
								/>
							)}
						/>
					</ConfigFormItem>
				</Col>
			)}
			{!isImageOrAudioModel && (
				<>
					<Col xs={24} sm={12} md={5}>
						<ConfigFormItem label="Window Size" error={errors?.windowSize?.message}>
							<Controller
								name="windowSize"
								control={control}
								render={({ field }) => (
									<Input
										{...field}
										onChange={(e) =>
											field.onChange(e.target.value === '' ? null : parseInt(e.target.value))
										}
									/>
								)}
							/>
						</ConfigFormItem>
					</Col>
					<Col xs={24} sm={12} md={5}>
						<ConfigFormItem label="Step" error={errors?.step?.message}>
							<Controller
								name="step"
								control={control}
								render={({ field }) => (
									<Input
										{...field}
										onChange={(e) =>
											field.onChange(e.target.value === '' ? null : parseInt(e.target.value))
										}
									/>
								)}
							/>
						</ConfigFormItem>
					</Col>
				</>
			)}
			<Col xs={24} sm={12} md={4} style={{ marginBottom: 2 }}>
				<ConfigFormItem noLabel error={errors?.normalization?.message}>
					<Controller
						name="normalization"
						control={control}
						render={({ field }) => (
							<Tip title={normalizationTooltip}>
								<Checkbox
									{...field}
									checked={field.value}
									onChange={(e) => field.onChange(e.target.checked)}
								>
									Normalization
								</Checkbox>
							</Tip>
						)}
					/>
				</ConfigFormItem>
			</Col>
		</Row>
	);
};

export default ConfigModelForm;

const Tip = styled(Tooltip).attrs({
	arrow: false,
	placement: 'top',
	overlayInnerStyle: { width: '300px' },
})`
	.ant-checkbox-inner {
		border: 1px solid #ffaf02;
	}
`;
const ConfigFormItem = styled(FormItem)`
	margin-bottom: 0;
`;
